// extracted by mini-css-extract-plugin
module.exports = {"section":"LandingPage_section__2W21h","heading":"LandingPage_heading__2RDVU"};